/**
 * "Zo klinkt deze fluit" (snippets/fluit-geluid.liquid).
 *
 * Audiospeler per opname: play/stop-knop, golfvorm uit de echte opname (RMS per
 * 1/40e van de clip, vooraf berekend en hieronder ingebakken) die tijdens het
 * afspelen oranje vult, tijdteller, en klikken op de golfvorm springt naar dat punt.
 * Er speelt hooguit één opname tegelijk, ook over meerdere instanties heen.
 * Kan een opname niet laden, dan wordt die rij uitgeschakeld; de rest blijft werken.
 */

if (!customElements.get('hbj-fluit-geluid')) {
  const PEAKS = {"acme-210-5":{"d":8.3,"p":[1.0,0.22,0.12,0.13,0.13,0.11,0.15,0.13,0.13,0.27,0.57,0.18,0.16,0.19,0.12,0.26,0.27,0.51,0.28,0.19,0.27,0.45,0.21,0.27,0.84,0.17,0.15,0.17,0.11,0.3,0.72,0.99,0.86,0.17,0.14,0.14,0.14,0.18,0.25,0.08]},"acme-211-5":{"d":8.4,"p":[0.25,0.29,0.28,0.2,0.26,0.33,0.69,0.33,0.36,0.28,0.25,1.0,0.33,0.27,0.2,0.95,0.38,0.16,0.48,0.16,0.38,0.24,0.38,0.22,0.17,0.77,0.42,0.36,0.27,0.34,0.25,1.0,0.28,0.59,0.62,0.65,0.43,0.21,0.69,0.08]},"acme-212":{"d":10.6,"p":[0.22,0.11,0.31,0.69,0.12,0.09,0.08,0.24,0.72,0.15,0.09,0.17,0.51,0.58,0.14,0.53,0.61,0.21,0.2,0.58,1.0,0.12,0.71,0.15,0.23,0.37,0.59,0.2,0.5,0.13,0.15,0.59,0.37,0.43,0.55,0.7,0.63,0.11,0.11,0.08]},"acme-560":{"d":6.0,"p":[0.76,1.0,0.94,0.94,0.97,0.82,0.25,0.23,0.11,0.56,0.83,0.93,0.94,0.95,0.95,0.89,0.88,0.91,0.89,0.89,0.93,0.91,0.89,0.9,0.75,0.7,0.61,0.76,0.8,0.76,0.72,0.93,0.92,0.91,0.93,0.64,0.24,0.13,0.08,0.08]},"acme-640":{"d":4.0,"p":[0.08,0.22,1.0,0.82,0.74,0.74,0.75,0.72,0.49,0.42,0.32,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.08,0.23,0.22,0.14,0.08,0.1,0.11,0.21,0.16,0.28,0.24,0.11,0.08,0.08,0.08]},"acme-641":{"d":8.1,"p":[0.47,0.56,0.32,0.68,0.4,0.29,0.39,0.44,0.45,0.2,0.14,1.0,0.44,0.61,0.5,0.45,0.45,0.25,0.12,0.13,0.16,0.12,0.13,0.08,0.08,0.41,0.26,0.25,0.23,0.29,0.24,0.31,0.14,0.08,0.54,0.33,0.31,0.29,0.28,0.32]},"acme-660":{"d":5.8,"p":[0.48,0.88,0.9,0.93,0.91,0.96,0.91,0.26,0.26,0.08,0.6,1.0,0.95,0.96,0.85,0.44,0.56,0.82,0.89,0.85,0.92,1.0,0.88,0.88,0.86,0.84,0.7,0.23,0.42,0.67,0.68,0.73,0.87,0.82,0.98,0.7,0.27,0.11,0.08,0.08]},"acme-t2000":{"d":7.5,"p":[0.64,0.61,0.83,0.68,0.97,1.0,0.86,0.35,0.22,0.08,0.4,0.75,0.86,0.69,0.64,0.52,0.53,0.28,0.14,0.08,0.46,0.67,0.41,0.25,0.6,0.34,0.74,0.45,0.74,0.28,0.16,0.08,0.77,0.84,0.6,0.64,0.82,0.32,0.09,0.08]}};

  const formatTime = (s) => {
    const sec = Math.max(0, Math.round(s || 0));
    return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`;
  };

  class HbjFluitGeluid extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.js-fluit-item'));
      this.items.forEach((item) => this.setupItem(item));
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        if (item._audio && !item._audio.paused) item._audio.pause();
      });
    }

    setupItem(item) {
      const audio = item.querySelector('.js-fluit-audio');
      const btn = item.querySelector('.js-fluit-btn');
      const wave = item.querySelector('.js-fluit-wave');
      const time = item.querySelector('.js-fluit-time');
      if (!audio || !btn || !wave) return;

      item._audio = audio;
      item._bars = Array.from(wave.querySelectorAll('i'));
      const data = PEAKS[item.dataset.slug];
      item._duration = data ? data.d : 0;
      if (data) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          item._bars.forEach((bar, i) => {
            const p = data.p[i];
            if (typeof p === 'number') bar.style.height = `${Math.round(p * 100)}%`;
          });
        }));
      }
      if (time) time.textContent = formatTime(item._duration);

      btn.addEventListener('click', () => this.toggle(item));
      btn.addEventListener('pointerup', (evt) => {
        if (evt.pointerType !== 'keyboard') setTimeout(() => btn.blur(), 0);
      });

      wave.addEventListener('click', (evt) => {
        if (item.classList.contains('is-error')) return;
        const rect = wave.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (evt.clientX - rect.left) / rect.width));
        this.seek(item, ratio);
      });

      audio.addEventListener('loadedmetadata', () => {
        if (isFinite(audio.duration) && audio.duration > 0) item._duration = audio.duration;
        if (audio.paused && time) time.textContent = formatTime(item._duration);
      });
      audio.addEventListener('play', () => {
        HbjFluitGeluid.stopOthers(audio);
        this.setState(item, true);
        this.tick(item);
      });
      audio.addEventListener('pause', () => this.setState(item, false));
      audio.addEventListener('ended', () => {
        this.setState(item, false);
        this.paint(item, 0);
        if (time) time.textContent = formatTime(item._duration);
      });
      audio.addEventListener('error', () => {
        this.setState(item, false);
        item.classList.add('is-error');
        btn.disabled = true;
        btn.setAttribute('aria-label', 'Opname niet beschikbaar');
        if (time) time.textContent = 'niet beschikbaar';
      });
    }

    toggle(item) {
      const audio = item._audio;
      if (!audio) return;
      if (audio.paused) {
        if (audio.ended || audio.currentTime >= (item._duration || Infinity)) {
          try { audio.currentTime = 0; } catch (e) { /* nog niet geladen */ }
        }
        const promise = audio.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => this.setState(item, false));
        }
      } else {
        audio.pause();
      }
    }

    seek(item, ratio) {
      const audio = item._audio;
      const target = ratio * (item._duration || 0);
      const apply = () => {
        try { audio.currentTime = target; } catch (e) { /* metadata ontbreekt nog */ }
        this.paint(item, ratio);
        if (audio.paused) {
          const promise = audio.play();
          if (promise && typeof promise.catch === 'function') promise.catch(() => {});
        }
      };
      if (audio.readyState >= 1) {
        apply();
      } else {
        audio.addEventListener('loadedmetadata', apply, { once: true });
        audio.load();
      }
    }

    tick(item) {
      const audio = item._audio;
      if (audio.paused) return;
      const dur = item._duration || audio.duration || 0;
      const ratio = dur ? audio.currentTime / dur : 0;
      this.paint(item, ratio);
      const time = item.querySelector('.js-fluit-time');
      if (time) time.textContent = formatTime(audio.currentTime);
      requestAnimationFrame(() => this.tick(item));
    }

    paint(item, ratio) {
      const n = item._bars.length;
      const count = Math.round(ratio * n);
      item._bars.forEach((bar, i) => {
        bar.classList.toggle('is-past', i < count);
        bar.classList.toggle('is-current', i === count - 1 && count > 0);
      });
    }

    setState(item, playing) {
      item.classList.toggle('is-playing', playing);
      const btn = item.querySelector('.js-fluit-btn');
      if (!btn || btn.disabled) return;
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? btn.dataset.stopLabel : btn.dataset.playLabel);
    }

    static stopOthers(current) {
      document.querySelectorAll('hbj-fluit-geluid .js-fluit-audio').forEach((audio) => {
        if (audio !== current && !audio.paused) audio.pause();
      });
    }
  }

  customElements.define('hbj-fluit-geluid', HbjFluitGeluid);
}
